import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=124feb5e&scoped=true&"
import script from "./LoginLayout.vue?vue&type=script&lang=js&"
export * from "./LoginLayout.vue?vue&type=script&lang=js&"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=124feb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124feb5e",
  null
  
)

component.options.__file = "www/vues/login/LoginLayout.vue"
export default component.exports